<div class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-content p-a-0">
    <div class="box has-text-dark p-a-lg">
      <h2 class="title is-3">Modify this {{ resourceName }}</h2>

      <div class="tabs is-boxed">
        <ul class="my-0">
          <li
            class="mb-0 is-active"
            [ngClass]="{ 'is-active': !isUserSubmitter }"
          >
            <a
              class="no-deco is-size-7"
              [ngClass]="{
                'has-text-link': !isUserSubmitter,
                'has-text-dark': isUserSubmitter
              }"
              (click)="isUserSubmitter = false"
              (keydown)="isUserSubmitter = false"
              tabindex="0"
              >I did not submit this {{ resourceName }}</a
            >
          </li>
          <li
            class="mb-0 ml-1"
            [ngClass]="{
              'is-active': isUserSubmitter
            }"
          >
            <a
              class="no-deco is-size-7"
              [ngClass]="{
                'has-text-link': isUserSubmitter,
                'has-text-dark': !isUserSubmitter
              }"
              (click)="isUserSubmitter = true"
              (keydown)="isUserSubmitter = true"
              tabindex="0"
              >I submitted this {{ resourceName }}</a
            >
          </li>
        </ul>
      </div>
      <div class="panes">
        <div class="tabs-pane" *ngIf="!isUserSubmitter">
          <form
            novalidate
            [formGroup]="form"
            (submit)="askForChange(form.value)"
          >
            <div class="field">
              <label class="is-size-7" for="description"
                >What would you like to have modified and why ?<span
                  class="has-text-danger"
                  >*</span
                ></label
              >
              <app-rich-text-input
                uniqueId="description"
                placeholder="Explain briefly the reasons why you ask a modification..."
                (valueChanged)="onDescriptionChanged($event.value)"
                [required]="true"
              ></app-rich-text-input>
            </div>

            <div class="field mb-5">
              <label class="is-size-7" for="email"
                >Your email<span class="has-text-danger">*</span></label
              >
              <div class="control mb-4">
                <input
                  class="input is-large"
                  placeholder="your-email@organisation.com"
                  type="email"
                  formControlName="email"
                  id="email"
                />
              </div>
            </div>

            <div class="field mb-5">
              <label class="is-size-7" for="affiliation"
                >Your affiliation and or/relation with this {{ resourceName }}
                <span class="has-text-danger">*</span></label
              >
              <div class="control mb-4">
                <input
                  class="input is-large"
                  placeholder="Your affiliation..."
                  type="text"
                  formControlName="affiliation"
                  id="affiliation"
                />
              </div>
            </div>

            <re-captcha
              formControlName="captcha"
              [siteKey]="captchaKey"
              required
            ></re-captcha>
            <div class="level is-mobile m-t-gutter">
              <div class="level-left">
                <div class="level-item">
                  <a
                    (click)="modalClosed.emit()"
                    (keydown)="modalClosed.emit()"
                    tabindex="0"
                    class="button is-light is-outlined"
                  >
                    <span class="has-text-dark">Cancel</span>
                  </a>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <button class="button is-link" [disabled]="form.invalid">
                    Submit modification request
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="tabs-pane" *ngIf="isUserSubmitter">
          <p>
            Only the submitter can modify this {{ resourceName }}. By clicking
            on the "modify" button, the submitter will receive an email with a
            link to edit this {{ resourceName }}.
          </p>
          <div
            class="is-flex is-align-items-center is-justify-content-space-between"
          >
            <a
              (click)="modalClosed.emit()"
              (keydown)="modalClosed.emit()"
              tabindex="0"
              class="button is-white-ter px-5"
              >Cancel</a
            >
            <a
              class="button is-link"
              (click)="askForEditAccess()"
              (keydown)="askForEditAccess()"
              tabindex="0"
              >Modify</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
